import styles from "./campaigncard.module.css";
import { Link } from "react-router-dom";
import { BarChart2, Copy, Edit, Eye, EyeOff, MoreVertical, Send, Trash2 } from "react-feather";
import moment from "moment";
import { Dropdown } from "react-bootstrap";

const CampaignCard = ({ item, navigateTo, setSendModalOpen, setSelectedItem, setDeleteModalOpen, setArchiveModalOpen, setPublishModalOpen, copyCampign }) => {

    return (<Link className={`${styles.ProspectCard}`} key={item?.id} to={`/campaign/campaigns/preview/${item?.id}`}>
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                        <Dropdown.Item onClick={() => { navigateTo(`/campaign/campaigns/preview/${item?.id}`); }} className={`${styles.EditActionsBUListItem}`}>
                            <Eye /> Preview
                        </Dropdown.Item>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setSendModalOpen(true); setSelectedItem(item); }}>
                            <Send /> Send
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => { navigateTo(`/campaign/campaigns/edit/${item?.id}`); }} className={`${styles.EditActionsBUListItem}`}>
                            <Edit /> Edit
                        </Dropdown.Item>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { copyCampign(item?.id); }}>
                            <Copy /> Copy
                        </Dropdown.Item>
                        {item?.is_archived === 0 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setArchiveModalOpen(true); setSelectedItem(item); }}>
                            <EyeOff /> Unpublished
                        </Dropdown.Item>}
                        {item?.is_archived === 1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setPublishModalOpen(true); setSelectedItem(item); }}>
                            <Eye /> Published
                        </Dropdown.Item>}
                        <Dropdown.Item onClick={() => { localStorage.setItem("emailAnalyticsCampaign", item?.id); navigateTo(`/campaign/analytics`); }} className={`${styles.EditActionsBUListItem}`}>
                            <BarChart2 /> Email Analytics
                        </Dropdown.Item>
                        <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectedItem(item); }}>
                            <Trash2 /> Delete
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <div className={`${styles.ProsIMGSec}`}>
                    <img src="/static/img/email-template.svg" alt="" />
                </div>
                <div className={`${styles.HeadConSec}`}>
                    <p className={`${styles.ProsUserName}`}>
                        <span className={`${styles.UserName}`}>{item?.title}</span>
                    </p>
                </div>
            </div>
            <div className={`${styles.ProspectCardFootSec}`}>
                <p className={`${styles.LeaseConDate}`}>{moment(item?.created_at).fromNow()}</p>
                <span className={`${styles.PublishBadge}`}>{item?.is_archived === 0 ? "Published" : "Unpublished"}</span>
            </div>
        </div>
    </Link>);
}

export default CampaignCard;